
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import ExpandableSection from '../Container/ExpandableSection';

interface HTMLElementWithExpander extends HTMLElement {
    expander: MdsLax<InstanceType<typeof ExpandableSection>>
//    node: HTMLElement
}

enum ExpandableSectionMarkings {
    "empty"= "empty",
    "optional"= "optional",
    "default" = "default",
    "checked" = "checked",
    "warning" = "warning",
    "hasContent" = "hasContent",
    "hidden" = "hidden"
}

type _WidgetBaseSPWithExpander__mdsbase = InstanceType<typeof _WidgetBaseSP>;
export interface _WidgetBaseSPWithExpander extends _WidgetBaseSPWithExpander__mdsbase {
    expander: MdsLax<InstanceType<typeof ExpandableSection>>
}

export {
    ExpandableSection, ExpandableSectionMarkings, type HTMLElementWithExpander
}
